import { render, staticRenderFns } from "./GenericTaxDetailsForm.vue?vue&type=template&id=01642642&"
import script from "./GenericTaxDetailsForm.vue?vue&type=script&lang=ts&"
export * from "./GenericTaxDetailsForm.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports